const defaultDepositSettings = {
  isEnabled: false,
  amount: 25,
  type: 'percentage',
  cancellationPolicy: {
    timeframe: 24,
    refundPolicy:
      'Full refund if cancelled at least 24 hours before your appointment. Late cancellations and no-shows forfeit the deposit.',
    termsAndConditions: '',
  }
};

export const getDefaultDepositSettings = () => defaultDepositSettings; 